<template>
    <div class="component" data-app>
        <v-select
                attach
                v-model="newValue"
                v-bind:id="id"
                v-bind:label="label"
                v-bind:items="options"
                v-on:input="onChange"
        ></v-select>
    </div>
</template>

<script type="text/babel">
    import {VSelect} from 'vuetify/lib'

    export default {
        name: 'components-forms-select-index',
        watch: {
            value() {
                this.newValue = this.value;
            }
        },
        props: {
            value: undefined,
            id: undefined,
            type: {
                default: 'text'
            },
            label: {
                default: undefined
            },
            placeholder: {
                default: undefined
            },
            options: {
                required: true
            }
        },
        data() {
            return {
                newValue: undefined
            }
        },
        methods: {
            onChange() {
                this.$emit('input', this.newValue);
            }
        },
        computed: {},
        created() {
            this.newValue = this.value;
        },
        mounted() {
        },
        beforeDestroy() {
        },
        mixins: [],
        components: {
            VSelect
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
